import React from 'react';
import cn from 'classnames';

const FormBlock = ({ children, title, subTitle, className }) => {
  return (
    <div className={cn('admin-form__block', className)}>
      {title && <p className="admin-form__block__title">{title}</p>}
      {subTitle && <p className="admin-form__block__description">{subTitle}</p>}
      {children}
    </div>
  );
};

export default FormBlock;
